import { CenterContainer } from '@common/containers'
import { Box, Grid2 as Grid, Paper, Skeleton } from '@mui/material'

const Placeholder = () => {
  return (
    <CenterContainer fullScreen>
      <Grid container spacing={2} justifyContent='center' alignItems='center'>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Skeleton variant='circular' width={200} height={200} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Skeleton variant='circular' width={200} height={200} />
        </Grid>
      </Grid>
    </CenterContainer>
  )
}

export default Placeholder
